import { Skeleton, Stack, Tabs } from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import { useState } from 'react';
import { useGetMyReward } from '@/features/loyalty/api/reward/use-get-my-reward';
import MyRewardCard from '@/features/loyalty/reward/my-reward-card';

const MyRewardListModal = ({ context }: ContextModalProps) => {
  const [activeTab, setActiveTab] = useState<string | null>('new');
  const {
    data: activeRewards,
    isLoading,
    refetch,
    isFetching,
  } = useGetMyReward({ is_used: false });

  const {
    data: usedRewards,
    isLoading: isLoadingUsed,
    refetch: refetchUsed,
    isFetching: isFetchingUsed,
  } = useGetMyReward({ is_used: true });

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
      styles={{
        list: {
          position: 'sticky',
          top: 0,
          left: 0,
          background: 'white',
          zIndex: 10,
        },
        root: {
          color: 'gray !important', // Default color for inactive tabs
          '&[data-active]': {
            color: 'black', // Color for active tabs
          },
        },
      }}
    >
      <Tabs.List grow justify="space-between">
        <Tabs.Tab fw={700} w="50%" value="new">
          Mới
        </Tabs.Tab>
        <Tabs.Tab fw={700} w="50%" value="second">
          Hết hiệu lực
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="new">
        <Stack p={16} gap={12} mb={80} bg="neutral.1">
          {isLoading ? (
            <Stack>
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton w="100%" h={100} key={index} />
              ))}
            </Stack>
          ) : activeRewards?.length === 0 ? (
            <p>Không có ưu đãi nào</p>
          ) : (
            activeRewards?.map((reward) => (
              <MyRewardCard rewardData={reward} key={reward.id} />
            ))
          )}
        </Stack>
      </Tabs.Panel>
      <Tabs.Panel value="second">
        <Stack p={16} gap={12} mb={80} bg="neutral.1">
          {isLoadingUsed ? (
            <Stack>
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton w="100%" h={100} key={index} />
              ))}
            </Stack>
          ) : usedRewards?.length === 0 ? (
            <p>Không có ưu đãi nào</p>
          ) : (
            usedRewards?.map((reward) => (
              <MyRewardCard rewardData={reward} key={reward.id} isUsed />
            ))
          )}
        </Stack>
      </Tabs.Panel>
    </Tabs>
  );
};

export default MyRewardListModal;
